import {Link} from "react-router-dom";
import {fileFormat} from "../../../utils/constants";
import ImageComponent from "./ImageComponent";
import {buildImageUrl} from "../../../utils/imageUrlBuilder";
import NoImage from "../../../images/NoImage.jpg";
import {useSelector} from "react-redux";

const PubList = () => {
  const {pubList} = useSelector((state) => state.pubs);

  return (
    <>
      {pubList?.length > 0 && (
        <>
          {pubList.map((pub) =>
            pub?.FileUploads?.length && pub?.FileUploads[0]?.path ? (
              <Link
                target="_blank"
                rel="noopener noreferrer"
                className="w-full"
                to={pub?.link ?? "#"}
                key={pub?.id}
              >
                {pub?.FileUploads[0]?.format === fileFormat.IMAGE ? (
                  <ImageComponent
                    src={buildImageUrl(pub?.FileUploads[0]?.path)}
                    alt=""
                    className="w-full h-auto !rounded-2xl"
                    fallback={
                      <img
                        src={NoImage}
                        className="w-full object-cover !rounded-2xl"
                        alt=""
                      />
                    }
                  />
                ) : (
                  <video className="w-full object-cover !rounded-2xl" controls>
                    <source
                      src={buildImageUrl(pub?.FileUploads[0]?.path)}
                      type="video/mp4"
                    />
                    Your browser does not support the video tag.
                  </video>
                )}
              </Link>
            ) : null,
          )}
        </>
      )}
    </>
  );
};

export default PubList;
